import api from '../config/Api';

const endpoint = 'v1/attribute-iplusd-cost';

export default {

  getAttributeIDCostParams( attributeId, params ) {
    return api.get( `${endpoint}/${attributeId}`, params );
  },

  updateAttributeIDCostParam( id, data ) {
    return api.put( `${endpoint}/${id}`, data );
  },
};
